module.exports = __webpack_public_path__ + "img/berts-point-award.ffd5738d.svg";